import * as yup from "yup";

export const visitorIdProofSchema = yup.object({
  type_name: yup
    .string()
    .trim()
    .required("Type name is required"),
  status_id: yup
    .string()
    .oneOf(["1", "2"], "Select Active or Inactive")
    .required("Status is required"),
});

export const visitorIdProofFormDefaults = {
  type_name: "",
  status_id: "1",
};
